import { useState } from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { faqPreviewData } from "../../../mocks/homeData";

export default function FAQPreview() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{faqPreviewData.label}</p>
              <h2 className="section-title">{faqPreviewData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="flex flex-col gap-3">
            {faqPreviewData.items.map((item, idx) => (
              <ScrollReveal key={idx} direction="up" delay={idx * 80}>
                <div className="border border-airdoa-gray-light/50 rounded-lg bg-white overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                    className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-airdoa-navy pr-4">
                      {item.q}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center shrink-0 text-airdoa-gold transition-transform duration-300">
                      <i className={`ri-${openIdx === idx ? "subtract" : "add"}-line text-lg`} />
                    </span>
                  </button>
                  {openIdx === idx && (
                    <div className="px-5 pb-5">
                      <p className="text-sm text-airdoa-gray leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-8 text-center">
              <Link to={faqPreviewData.cta.href} className="btn-secondary">
                {faqPreviewData.cta.label}
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}